import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AdminApiContext = createContext();
export const useAdminApi = () => useContext(AdminApiContext);

export const AdminApiProvider = ({ children }) => {
  const [tariffs,  setTariffs]  = useState([]);
  const [services, setServices] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState("");

  const normalize = (resp, key) =>
    Array.isArray(resp.data) ? resp.data : resp.data[key] ?? [];

  const refreshAll = async () => {
    try {
      setLoading(true);
      const [tRes, sRes] = await Promise.all([
        axios.get("/api/admin/tariffs"),
        axios.get("/api/admin/services")
      ]);
      setTariffs(normalize(tRes, "tariffs"));
      setServices(normalize(sRes, "services"));
    } catch (e) {
      console.error(e);
      setError("Не удалось получить данные");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refreshAll(); }, []);

  const prepareTariffData = (data) => ({
    ...data,
    service_ids: (data.included_services || []).map(s => s.service_id), // теперь через ID
  });

  const prepareServiceData = (data) => ({ ...data });

  const createTariff = async (data) => {
    await axios.post(`/api/admin/tariffs`, prepareTariffData(data));
    refreshAll();
  };

  const updateTariff = async (id, data) => {
    await axios.put(`/api/admin/tariffs`, { id, ...prepareTariffData(data) });
    refreshAll();
  };
 const deleteTariff = async (id) => {
  try {
    await axios.delete(`/api/admin/tariffs`, { data: { id } });
    refreshAll();
  } catch (err) {
    console.error(err);
    alert(err.response?.data?.error || "Ошибка при удалении тарифа");
  }
};

  const createService = async (data) => {
    await axios.post(`/api/admin/services`, prepareServiceData(data));
    refreshAll();
  };

  const updateService = async (id, data) => {
    await axios.put(`/api/admin/services`, { id, ...prepareServiceData(data) });
    refreshAll();
  };

const deleteService = async (id) => {
  try {
    await axios.delete(`/api/admin/services`, { data: { id } });
    refreshAll();
  } catch (err) {
    console.error(err);
    alert(err.response?.data?.error || "Ошибка при удалении сервиса");
  }
};

  const value = {
    tariffs, services, loading, error,
    createTariff, updateTariff, deleteTariff,
    createService, updateService, deleteService
  };

  return <AdminApiContext.Provider value={value}>{children}</AdminApiContext.Provider>;
};
